// import { FaFileAlt, FaTrash } from 'react-icons/fa';

// export default function PersonalInfoSection({ personalInfo, setPersonalInfo }) {
//   const handleChange = (e) => {
//     setPersonalInfo({ ...personalInfo, [e.target.name]: e.target.value });
//   };

//   const handleFileChange = (file) => {
//     if (file && file.size <= 30 * 1024 * 1024) {
//       setPersonalInfo({ ...personalInfo, idFile: file });
//     } else {
//       alert('File too large or invalid format.');
//     }
//   };

//   const removeFile = () => {
//     setPersonalInfo({ ...personalInfo, idFile: null });
//   };

//   return (
//     <div className="space-y-4">
//       <input
//         type="text"
//         name="fullName"
//         placeholder="Full Name"
//         className="rounded-full border px-4 py-2 w-full"
//         value={personalInfo.fullName}
//         onChange={handleChange}
//         required
//       />

//       <input
//         type="date"
//         name="dob"
//         placeholder="Date of Birth"
//         className="rounded-full border px-4 py-2 w-full"
//         value={personalInfo.dob}
//         onChange={handleChange}
//         required
//       />

//       <input
//         type="text"
//         name="contact"
//         placeholder="Contact Number"
//         className="rounded-full border px-4 py-2 w-full"
//         value={personalInfo.contact}
//         onChange={handleChange}
//         required
//       />

//       <select
//         name="idType"
//         className="rounded-full border px-4 py-2 w-full text-gray-600"
//         value={personalInfo.idType}
//         onChange={handleChange}
//         required
//       >
//         <option value="">Select Type of Identification</option>
//         <option value="passport">International Passport</option>
//         <option value="driver">Driver’s License</option>
//         <option value="national">National ID</option>
//         <option value="other">Other</option>
//       </select>

//       {/* File Upload */}
//       <div>
//         <label className="block text-sm font-medium text-gray-700 mb-1">
//           Upload Identification Document <span className="text-gray-400 text-xs">(PDF, JPG, PNG, DOCX - max 30MB)</span>
//         </label>

//         <div
//           className="border-2 border-dashed border-gray-300 p-6 rounded-xl text-center cursor-pointer hover:border-primary hover:bg-blue-50 transition"
//           onClick={() => document.getElementById('id-upload').click()}
//           onDragOver={(e) => e.preventDefault()}
//           onDrop={(e) => {
//             e.preventDefault();
//             const file = e.dataTransfer.files[0];
//             handleFileChange(file);
//           }}
//         >
//           {personalInfo.idFile ? (
//             <div className="flex items-center justify-center space-x-2">
//               <FaFileAlt className="text-primary" />
//               <span className="text-sm text-gray-700">{personalInfo.idFile.name}</span>
//               <button
//                 type="button"
//                 className="text-red-500 hover:text-red-700 ml-2"
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   removeFile();
//                 }}
//               >
//                 <FaTrash />
//               </button>
//             </div>
//           ) : (
//             <div className="text-gray-400 text-sm">
//               Drag & drop or <span className="underline text-primary">browse</span> to upload
//             </div>
//           )}

//           <input
//             id="id-upload"
//             type="file"
//             accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
//             className="hidden"
//             onChange={(e) => handleFileChange(e.target.files[0])}
//           />
//         </div>
//       </div>
//     </div>
//   );
// }




import { useEffect } from 'react';
import { FaFileAlt, FaTrash } from 'react-icons/fa';

export default function PersonalInfoSection({ personalInfo, setPersonalInfo }) {
  const handleChange = (e) => {
    setPersonalInfo({ ...personalInfo, [e.target.name]: e.target.value });
  };

  const handleFileChange = (file) => {
    if (file && file.size <= 30 * 1024 * 1024) {
      setPersonalInfo({ ...personalInfo, idFile: file });
    } else {
      alert('File too large or invalid format.');
    }
  };

  const removeFile = () => {
    setPersonalInfo({ ...personalInfo, idFile: null });
  };

  // 👇 Automatically inject email from localStorage on mount
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user?.email) {
      setPersonalInfo(prev => ({
        ...prev,
        email: user.email,
      }));
    }
  }, [setPersonalInfo]);

  return (
    <div className="space-y-4">
      <input
        type="text"
        name="fullName"
        placeholder="Full Name"
        className="rounded-full border px-4 py-2 w-full"
        value={personalInfo.fullName}
        onChange={handleChange}
        required
      />
      <p className=''>Date of Birth</p>

      <input
        type="date"
        name="dob"
        placeholder="Date of Birth"
        className="rounded-full border px-4 py-2 w-full"
        value={personalInfo.dob}
        onChange={handleChange}
        required
      />

      <input
        type="text"
        name="contact"
        placeholder="Contact Number"
        className="rounded-full border px-4 py-2 w-full"
        value={personalInfo.contact}
        onChange={handleChange}
        required
      />

      <select
        name="idType"
        className="rounded-full border px-4 py-2 w-full text-gray-600"
        value={personalInfo.idType}
        onChange={handleChange}
        required
      >
        <option value="">Select Type of Identification</option>
        <option value="passport">International Passport</option>
        <option value="driver">Driver’s License</option>
        <option value="national">National ID</option>
        <option value="other">Other</option>
      </select>

      {/* File Upload */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Upload Identification Document <span className="text-gray-400 text-xs">(PDF, JPG, PNG, DOCX - max 30MB)</span>
        </label>

        <div
          className="border-2 border-dashed border-gray-300 p-6 rounded-xl text-center cursor-pointer hover:border-primary hover:bg-blue-50 transition"
          onClick={() => document.getElementById('id-upload').click()}
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => {
            e.preventDefault();
            const file = e.dataTransfer.files[0];
            handleFileChange(file);
          }}
        >
          {personalInfo.idFile ? (
            <div className="flex items-center justify-center space-x-2">
              <FaFileAlt className="text-primary" />
              <span className="text-sm text-gray-700">{personalInfo.idFile.name}</span>
              <button
                type="button"
                className="text-red-500 hover:text-red-700 ml-2"
                onClick={(e) => {
                  e.stopPropagation();
                  removeFile();
                }}
              >
                <FaTrash />
              </button>
            </div>
          ) : (
            <div className="text-gray-400 text-sm">
              Drag & drop or <span className="underline text-primary">browse</span> to upload
            </div>
          )}

          <input
            id="id-upload"
            type="file"
            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
            className="hidden"
            onChange={(e) => handleFileChange(e.target.files[0])}
          />
        </div>
      </div>
    </div>
  );
}
